import { Component, OnInit, ChangeDetectionStrategy, Input, ViewChild, AfterViewInit, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { E5ConfigurationService as e5Config } from 'e5core-angular-services';
import { WorkItemModel } from '../../models/work-item';
import { FileUploadModel } from '../../models/file-upload.model';
import { E5coreUiWorkAttachmentsMaterialComponent } from './component/e5core-ui-work-attachments-material.component';
import { ViewerDisplayEvent } from '../../events/viewer-display-event';
import { UiStyleService } from '../../services/ui-style.service';

// <e5core-ui-work-attachments-box *ngSwitchCase='0' [workItem$]='workItem$' [readonly]='readonly' [pagesizes]='pagesizes'></e5core-ui-work-attachments-box>
// <e5core-ui-work-attachments-bootstrap *ngSwitchCase='1' [workItem$]='workItem$' [readonly]='readonly' [pagesizes]='pagesizes'></e5core-ui-work-attachments-bootstrap>


@Component({
  selector: 'e5core-ui-work-attachments',
  template: `
  <span *ngIf="workItem$" [ngSwitch]="style.current()">
    <e5core-ui-work-attachments-material *ngSwitchCase='2' [workItem$]='workItem$' [readonly]='readonly' [pagesizes]='pagesizes' (attachmentDownloadEvent)='onAttachmentDownload($event)' (attachmentSelectEvent)='onAttachmentSelect($event)' ></e5core-ui-work-attachments-material>
  </span>
  <div *ngIf="!(workItem$)" class="e5core-component-error">&lt;e5core-ui-work-attachments&gt; [workItem$] must have a BehaviorSubject&lt;WorkItemModel&gt;</div>
  <iframe width="0" height="0" *ngIf="!(downloadUrl == '')" [src]="downloadUrl | safe" style="width:0;height:0;border:0; border:none; position: absolute;"></iframe>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class E5coreUiWorkAttachmentsComponent  implements AfterViewInit, OnInit {

  @Input() workItem$ : BehaviorSubject<WorkItemModel>;
  @Input() fileUpload$: BehaviorSubject<FileUploadModel>;
  @Input() readonly : boolean ;
  @Input() pagesizes : number[];  
  @Output() attachmentDownloadEvent = new EventEmitter();
  @Output() attachmentSelectEvent = new EventEmitter<ViewerDisplayEvent>();
  workId : string ;
  downloadUrl : any = '';
  
  @ViewChild(E5coreUiWorkAttachmentsMaterialComponent)
  private workAttachmentsMaterialComponent: E5coreUiWorkAttachmentsMaterialComponent;

  constructor(
    public style:UiStyleService, 
    private config: e5Config,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    if (typeof this.workItem$ == 'undefined') {
      console.error('e5core-ui-work-attachments [workItem$] must have a BehaviorSubject<WorkItemModel>');
      return ;
    }

    if (typeof this.workItem$ != 'undefined') {
      this.workItem$.subscribe(
        w => {
          this.updateData();
        }
      )
    }
    
    if (typeof this.fileUpload$ != 'undefined') {
      this.fileUpload$.subscribe(
        w => {
          this.updateData();
        }
      )
    }
  }
  
  ngAfterViewInit() {
  }

  refresh() {
    this.workAttachmentsMaterialComponent.refresh();
  }

  onAttachmentDownload(event) {
    var baseUrl = this.config.settings.apiServer.baseUrl;
    var scope = this.config.settings.apiServer.scope;

    var w = this.workItem$.getValue();
    this.downloadUrl = `${baseUrl}/${scope}/api/ui/Attachment/Download/${w.workId}/${event.element.Id}`;

    this.changeDetectorRef.detectChanges();
    setTimeout(()=>{ this.downloadUrl = ""; }, 200);
    
    this.attachmentDownloadEvent.emit(event);
  }

  onAttachmentSelect(viewerDisplayEvent) {
    this.attachmentSelectEvent.emit(viewerDisplayEvent);
  }

  private updateData():void {
  }
}